import { Injectable, OnDestroy } from '@angular/core';
import confetti from 'canvas-confetti';
import { PathwayLocalStorageUtil } from 'src/app/utils/pathway-localstorage.util';

const CONFETTI_COLORS = [
  '#6CB2BC', // $brand-400
  '#87C0C8', // $brand-300
  '#B0EBC8', // $green-10
  '#6EDEA1', // $green-6 / $success-1000
];

@Injectable({
  providedIn: 'root',
})
export class ConfettiService implements OnDestroy {
  private animationDone = false;

  ngOnDestroy(): void {
    this.stop();
  }

  launchForEnrollment(enrollmentUuid: string | null): void {
    if (!enrollmentUuid) return;
    if (PathwayLocalStorageUtil.hasConfettiBeenShown(enrollmentUuid)) return;

    PathwayLocalStorageUtil.markConfettiAsShown(enrollmentUuid);
    this.celebrate();
  }

  stop(): void {
    this.animationDone = true;
    confetti.reset();
  }

  protected fireConfetti(opts: confetti.Options): Promise<undefined> {
    return confetti(opts)!;
  }

  private celebrate(): void {
    const count = 1500;
    const defaults = {
      origin: { y: 0.5 },
      colors: CONFETTI_COLORS,
      shapes: ['square' as const],
      gravity: 0.8,  // lower = slower fall (default is 1)
      ticks: 800,    // higher = particles stay on screen longer (default is 200)
    };

    const sizes = [0.5, 1];
    const randomScalar = (): number => sizes[Math.floor(Math.random() * sizes.length)];

    const fire = (particleRatio: number, opts: confetti.Options): Promise<undefined> => {
      const scalar = opts.scalar ?? randomScalar();
      return this.fireConfetti({ ...defaults, ...opts, scalar, particleCount: Math.floor(count * particleRatio) });
    };

    this.animationDone = false;

    Promise.all([
      fire(0.25, { spread: 26, startVelocity: 30 }),
      fire(0.20, { spread: 60, startVelocity: 25 }),
      fire(0.35, { spread: 100, decay: 0.94, scalar: 0.8 }),
      fire(0.10, { spread: 120, startVelocity: 15, decay: 0.95, scalar: 1.2 }),
      fire(0.10, { spread: 120, startVelocity: 28 }),
    ]).then(() => {
      if (!this.animationDone) {
        this.stop();
      }
    });
  }
}
